import TasasEnum from "./tasasEnum"

const TipoImpuestoEnum = {
    IGV: {
        id_orden_impuesto: null,
        descripcion: "IGV",
        valor: TasasEnum.IGV.valor,
        valor_aplicado: 0,
        ori_tipo: 1
    },
    DETRACCION: {
        id_orden_impuesto: null,
        descripcion: "Detracción",
        valor: 0,
        valor_aplicado: 0,
        ori_tipo: 2
    },
    RETENCION: {
        id_orden_impuesto: null,
        descripcion: "Retención",
        valor: 0,
        valor_aplicado: 0,
        ori_tipo: 4
    },
    PERCEPCION: {
        id_orden_impuesto: null,
        descripcion: "Percepción",
        valor: 0,
        valor_aplicado: 0,
        ori_tipo: 3
    }
}

export default TipoImpuestoEnum